import * as Yup from "yup";

export const initialValues = (data) => {
  return {
    ...data,
    ...data?.localized_data,
    ...data?.dimensions,
    wrap_id: data?.wrap?.id,
  }
};

export const structure = (wrapId, options, t) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: `image`,
        kind: "upload",
        type: 'image',
        label: `${t("wrappers_shapes.wrap_photo")}*`,
        placeholder: t("wrappers_shapes.upload_placeholder"),
        text: t("wrappers_shapes.file_size_limit"),
        width: "47%",
      },

      {
        width: "47%",
      },
      {
        name: `en.name`,
        kind: "input",
        type: "text",
        label: `${t("wrappers_shapes.name_en")}*`,
        width: "47%",
        placeholder: t("wrappers_shapes.write_name_en")
      },
      {
        name: `ar.name`,
        kind: "input",
        type: "text",
        label: t("wrappers_shapes.name_ar"),
        width: "47%",
        placeholder: t("wrappers_shapes.write_name_ar")
      },
      {
        name: `wrap_id`,
        kind: "select",
        type: "text",
        label: `${t("wrappers_shapes.choose_wrap")}*`,
        width: "47%",
        placeholder: t("wrappers_shapes.choose_wrap"),
        // options: wrapsOptionsListArray
        ...options?.wraps
      },
      {
        name: `price`,
        kind: "input",
        type: "number",
        label: `${t("wrappers_shapes.price")}*`,
        width: "23%",
        placeholder: t("wrappers_shapes.enter_price"),
        EndAdornment: (
          <p style={{ fontSize: '18px', color: "#1A1A1A" }}>SAR</p>
        )
      },
      {
        name: `price_after_discount`,
        kind: "input",
        type: "number",
        label: `${t("wrappers_shapes.price_after_discount")}*`,
        width: "23%",
        placeholder: t("wrappers_shapes.enter_price"),
        EndAdornment: (
          <p style={{ fontSize: '18px', color: "#1A1A1A" }} >SAR</p>
        )
      },
      {
        name: `width`,
        kind: "input",
        type: "number",
        label: `${t("wrappers_shapes.width")}*`,
        width: "47%",
        placeholder: t("wrappers_shapes.write_width")
      },
      wrapId === "three" && {
        name: `height`,
        kind: "input",
        type: "number",
        label: `${t("wrappers_shapes.height")}*`,
        width: "47%",
        placeholder: t("wrappers_shapes.write_height"),
        EndAdornment: (
          <p style={{ fontSize: '18px', color: "#1A1A1A" }} >cm</p>
        ),
      },

      {
        name: `weight`,
        kind: "input",
        type: "number",
        label: `${t("wrappers_shapes.weight")}*`,
        width: "47%",
        placeholder: t("wrappers_shapes.write_weight"),
        EndAdornment: (
          <p style={{ fontSize: '18px', color: "#1A1A1A" }} >gm</p>
        )
      },
      wrapId === "three" && {
        name: `length`,
        kind: "input",
        type: "number",
        label: `${t("wrappers_shapes.depth")}*`,
        width: "47%",
        placeholder: t("wrappers_shapes.write_depth"),
        EndAdornment: (
          <p style={{ fontSize: '18px', color: "#1A1A1A" }} >cm</p>
        )
      },

    ],
  },
];

export const validationSchema = (wrapId, t) =>
  Yup.object({
    image: Yup.string().required('Required'),
    en: Yup.object().shape({
      name: Yup.string().required('Required'),
    }),
    // ar: Yup.object().shape({
    //   name: Yup.string().required('Required'),
    // }),
    price: Yup.number().required("required").min(0),
    price_after_discount: Yup.number()
      .required("required")
      .typeError("Invalid Price")
      .nullable()
      .test("is-greater", "Price After discount must be less than original price", function (value) {
        const { price } = this.parent;
        if (value === null) {
          return true; // Allow empty price_after_discount
        }
        return value <= price;
      }),

    height: wrapId === "three" && Yup.number().required("required"),
    length: wrapId === "three" && Yup.number().required("required"),
    weight: Yup.number().required("required"),
    width: Yup.number().required("required"),
    wrap_id: Yup.number().required("required"),
  },
  );